import { NavDrawerModel } from "../../../../../Models/NavDrawer/NavDrawer.Model";
import "./HamburgerButton.scss";

export function HamburgerButton(): React.ReactNode {
  const handleClick = (): void => {
    NavDrawerModel.toggle();
  };

  return (
    <div className="HamburgerButton-wrapper">
      <button className="HamburgerButton" onClick={handleClick} aria-label="Toggle navigation menu">
        <div className="hamburger-line hamburger-line--full" />
        <div className="hamburger-line hamburger-line--short" />
        <div className="hamburger-line hamburger-line--medium" />
      </button>
    </div>
  );
}
